import React, { useEffect, useMemo, useState } from 'react';

import {
  AutoRotateIcon,
  // HelpIcon,
  MapFloorPlanIcon,
  // PinIcon,
} from 'components/icons';
// import { AutoPlayIcon } from 'components/icons/AutoPlayIcon';
import { limitLetters } from 'utils/limitLetters';
import Menu from 'components/menu';

import { createPortal } from 'react-dom';

const MenuForceMobile = (props) => {
  const {
    currentPano,
    toggleRotate,
    shouldRotate,
    isShowMapFloorPlan,
    floorMaps,
    onSelect,
    scenes,
    setImageSize,
  } = props;

  const color = useMemo(() => 'yellow', []);

  const [isActiveMap, setIsActiveMap] = useState(false);

  const [openDropDown, setOpenDropDown] = useState(false);
  const [mapShowed, setMapShowed] = useState();

  useEffect(() => {
    setOpenDropDown(false);
  }, [currentPano]);

  useEffect(() => {
    if (floorMaps.length > 0 && currentPano) {
      const getLinkedFloorPlanFromOtherScene = (floorMaps, pano) => {
        return floorMaps.find((item) =>
          item.objects.length
            ? item.objects.some((obj) => obj.id === pano._id)
            : item
        );
      };

      const linkedFloorPlan = getLinkedFloorPlanFromOtherScene(
        floorMaps,
        currentPano
      );
      if (linkedFloorPlan) {
        setMapShowed(linkedFloorPlan);
      } else {
        setMapShowed(floorMaps[0]);
      }
    }
  }, [currentPano, floorMaps]);

  const handleSelectMap = (item) => {
    setMapShowed(item);
  };

  return (
    <>
      {createPortal(
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '10px',
            width: '390px',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px',
            }}
          >
            <div className="header_titles" style={{ flex: 1 }}>
              <div
                className="header_titles_title"
                style={{
                  color: 'white',
                  fontSize: '20px',
                  fontWeight: 700,
                  textShadow:
                    'rgba(0, 0, 0, 0.4) 1px 1px 1px, rgba(0, 0, 0, 0.2) -1px -1px 1px',
                  textTransform: 'uppercase',
                  // textWrap: 'nowrap',
                }}
              >
                {limitLetters(currentPano.title, 100)}
              </div>
            </div>

            <div className="logo" style={{ width: '80px' }}>
              <img
                style={{ maxHeight: '100%', maxWidth: '100%' }}
                src="/TheGlen-logo.png"
                alt="logo"
              />
            </div>
          </div>
        </div>,
        document.body
      )}
      {createPortal(
        <div
          style={{
            position: 'fixed',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            bottom: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '390px',
            padding: '0 10px',
            gap: '5px',
          }}
        >
          <div
            style={{
              flex: 1,
            }}
          >
            <Menu
              scenes={scenes}
              currentPano={currentPano}
              onSelect={onSelect}
            />
          </div>
          <div style={{ display: 'flex', gap: '2px' }}>
            <div
              className={`icon`}
              onClick={() => {
                toggleRotate();
              }}
            >
              <AutoRotateIcon shouldRotate={shouldRotate} activeColor={color} />
            </div>
            {isShowMapFloorPlan && (
              <>
                <div
                  className={`icon position-relative`}
                  onClick={() => setIsActiveMap(!isActiveMap)}
                >
                  <MapFloorPlanIcon active={isActiveMap} />
                </div>
                {isActiveMap &&
                  createPortal(
                    <div
                      style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999,
                        width: '150px',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        padding: '8px',
                        borderRadius: '8px',
                        backdropFilter: 'blur(5px)',
                      }}
                    >
                      <button
                        style={{
                          position: 'absolute',
                          top: '-8px',
                          right: '-8px',
                          padding: '4px',
                          borderRadius: '9999px',
                          border: 'none',
                          backgroundColor: '#bb1d1d',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          setIsActiveMap(false);
                        }}
                      >
                        <svg
                          height="14px"
                          version="1.1"
                          viewBox="-4 -4 22 22"
                          width="14px"
                          fill="#fff"
                        >
                          <g
                            fill="#fff"
                            fillRule="evenodd"
                            id="Page-1"
                            stroke="#fff"
                            strokeWidth="1"
                          >
                            <g
                              id="Core"
                              transform="translate(-341.000000, -89.000000)"
                            >
                              <g
                                id="close"
                                transform="translate(341.000000, 89.000000)"
                              >
                                <path
                                  d="M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z"
                                  id="Shape"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </button>
                      {mapShowed && (
                        <>
                          {floorMaps?.length > 1 && (
                            <div className="map_header">
                              <div
                                className="map_dropdown"
                                onClick={() => setOpenDropDown(!openDropDown)}
                              >
                                <span>
                                  {limitLetters(mapShowed.image.name, 15)}
                                </span>
                                <i className="map_arrow down"></i>
                                {openDropDown && (
                                  <div
                                    className={`map_dropdown_options ${
                                      openDropDown ? 'show' : ''
                                    }`}
                                  >
                                    <ul className="dropdown_items">
                                      {floorMaps?.map((item, index) => (
                                        <li
                                          onClick={() => handleSelectMap(item)}
                                          key={index}
                                        >
                                          {limitLetters(item.image.name, 10)}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="map_image">
                            <img
                              style={{ maxHeight: '100%', maxWidth: '100%' }}
                              src={mapShowed.image.url}
                              alt={mapShowed.image.name}
                              onLoad={(e) =>
                                setImageSize({
                                  width: e.target.naturalWidth,
                                  height: e.target.naturalHeight,
                                })
                              }
                            />
                            {mapShowed.objects.map((viewpoint) => {
                              const currentPoint =
                                viewpoint.id === currentPano._id;
                              const [left, top] = viewpoint.coordinates;
                              const leftInPercent = left * 100;
                              const topInPercent = top * 100;
                              const currentScene =
                                scenes.find((s) => s._id === viewpoint.id) ||
                                {};
                              const tooltipId = `tooltip-${viewpoint.id}`;

                              const handleMouseEnter = () => {
                                const tooltip =
                                  document.getElementById(tooltipId);
                                if (tooltip) tooltip.style.opacity = '1';
                              };

                              const handleMouseLeave = () => {
                                const tooltip =
                                  document.getElementById(tooltipId);
                                if (tooltip) tooltip.style.opacity = '0';
                              };

                              return (
                                <React.Fragment key={viewpoint.id}>
                                  <div
                                    className={`viewpoint-container ${
                                      currentPoint
                                        ? 'current-viewpoint'
                                        : 'viewpoint'
                                    } `}
                                    style={{
                                      left: `${leftInPercent}%`,
                                      top: `${topInPercent}%`,
                                    }}
                                    onClick={() =>
                                      onSelect(
                                        currentScene.groupId,
                                        currentScene.id
                                      )
                                    }
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                  >
                                    <div className="hover-point"></div>
                                  </div>
                                  <p
                                    id={tooltipId}
                                    className="scene-title-tooltip"
                                    style={{
                                      position: 'absolute',
                                      left: `${leftInPercent}%`,
                                      top: `${topInPercent}%`,
                                      transform:
                                        'translate(-50%, calc(-100% - 15px))',
                                      zIndex: 999999,
                                      opacity: 0,
                                      pointerEvents: 'none',
                                      padding: '5px',
                                      borderRadius: '5px',
                                      fontSize: '12px',
                                      whiteSpace: 'nowrap',
                                      color: '#fff',
                                      backgroundColor: '#000',
                                      transition: 'opacity 0.2s',
                                    }}
                                  >
                                    {currentScene.title}
                                    <span
                                      style={{
                                        content: '',
                                        position: 'absolute',
                                        top: 'calc(100% - 3px)',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        borderLeft: '8px solid transparent',
                                        borderRight: '8px solid transparent',
                                        borderTop: '8px solid #000',
                                      }}
                                    ></span>
                                  </p>
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </>
                      )}
                    </div>,
                    document.body
                  )}
              </>
            )}
          </div>
        </div>,
        document.body
      )}
    </>
  );

  // return (
  //   <div
  //     className={`menuForceMobile-desktop--container ${
  //       isFreePlan ? 'banner_container' : ''
  //     }`}
  //     style={{
  //       position: 'fixed',
  //       top: 0,
  //       left: 0,
  //       width: '100%',
  //       height: '100vh',
  //       padding: '10px 0',
  //       pointerEvents: 'none',
  //     }}
  //   >
  //     {isFreePlan && <Banner />}
  //     {isMenuGallery && (
  //       <GalleryMenu
  //         scenes={scenes}
  //         desktop={true}
  //         groups={groups}
  //         onSelect={onSelect}
  //         activeColor={color}
  //         currentPano={currentPano}
  //         openMenu={openMenu}
  //         handleOpenMenu={handleOpenMenu}
  //       />
  //     )}

  //     {isSchoolLayout && (
  //       <SchoolLayoutMenu
  //         menuList={menuList}
  //         scenes={scenes}
  //         desktop={true}
  //         groups={groups}
  //         onSelect={onSelect}
  //         activeColor={color}
  //         currentPano={currentPano}
  //         openMenu={openMenu}
  //         handleOpenMenu={handleOpenMenu}
  //         isSchoolLayout={isSchoolLayout}
  //       />
  //     )}

  //     <div
  //       className="menuForceMobile-desktop--container_inner"
  //       style={{
  //         width: '100%',
  //         height: '100%',
  //         display: 'flex',
  //         flexDirection: 'column',
  //         justifyContent: 'space-between',
  //         alignItems: 'center',
  //         padding: '0 10px',
  //         boxSizing: 'border-box',
  //         pointerEvents: 'none',
  //       }}
  //     >
  //       <div
  //         className={`menuForceMobile-desktop--container_left ${
  //           isMenuGallery
  //             ? `container-width ${!openMenu && 'container-width-closed'}`
  //             : ''
  //         } ${isSimpleLayout ? 'hide-menu' : ''}`}
  //         style={{
  //           width: '100%',
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: '100%',
  //             display: 'flex',
  //             justifyContent: 'space-between',
  //             gap: '10px',
  //           }}
  //         >
  //           {/* {!isMenuGallery && !isSchoolLayout && (
  //             <div
  //               className="header"
  //               onClick={() => toggleMenu(tour.isPublic ? false : !isNavOpen)}
  //               style={{ cursor: ` ${tour.isPublic ? 'default' : 'pointer'}` }}
  //             >
  //               <div className="header_icon">
  //                 <PinIcon color={color} />
  //               </div>
  //               <div className="header_titles">
  //                 <div className="header_titles_title" style={{ color }}>
  //                   {currentPano ? limitLetters(currentPano.title, 100) : null}
  //                 </div>
  //                 <p className="header_titles_label">{subTitle || null}</p>
  //               </div>
  //             </div>
  //           )} */}

  //           {currentPano ? (
  //             <div className="header_titles" style={{ flex: 1 }}>
  //               <div
  //                 className="header_titles_title"
  //                 style={{
  //                   color: 'white',
  //                   fontSize: '20px',
  //                   fontWeight: 700,
  //                   textShadow:
  //                     'rgba(0, 0, 0, 0.4) 1px 1px 1px, rgba(0, 0, 0, 0.2) -1px -1px 1px',
  //                   textTransform: 'uppercase',
  //                   // textWrap: 'nowrap',
  //                 }}
  //               >
  //                 {limitLetters(currentPano.title, 100)}
  //               </div>
  //             </div>
  //           ) : null}

  //           {/* <PanoMenu
  //             isOpen={isNavOpen}
  //             menu={menuList}
  //             location={menuPosition}
  //             onClose={() => toggleMenu(false)}
  //             onSelect={menuOpenScene}
  //             color={color}
  //           /> */}
  //           <div className="logo" style={{ width: '80px' }}>
  //             <img
  //               style={{ maxHeight: '100%', maxWidth: '100%' }}
  //               src="/TheGlen-logo.png"
  //               alt="logo"
  //             />
  //           </div>
  //         </div>
  //       </div>
  //       <div
  //         className="menuForceMobile-desktop--container_right"
  //         style={{
  //           display: 'flex',
  //           width: '100%',
  //           alignItems: 'center',
  //           justifyContent: 'space-between',
  //           gap: '10px',
  //         }}
  //       >
  //         <div
  //           className={`icons_left ${
  //             isMenuGallery && !openMenu ? 'margin-left__0' : ''
  //           }`}
  //           style={{ position: 'relative', width: '100%', flex: 1 }}
  //         >
  //           <Menu
  //             scenes={scenes}
  //             currentPano={currentPano}
  //             onSelect={onSelect}
  //           />
  //           {shouldShowMapIcon && (
  //             <div
  //               className="icon"
  //               style={{
  //                 display: isShowOnMap ? 'flex' : 'none',
  //               }}
  //               onClick={() => handleUpdateRoute(configs.mapRoute)}
  //             >
  //               <MapIcon />
  //             </div>
  //           )}
  //         </div>
  //         {isSchoolLayout && (
  //           <SchoolLayoutIcons
  //             currentPano={currentPano}
  //             isAutoPlay={isAutoPlay}
  //             color={color}
  //             toggleHelpButton={toggleHelpButton}
  //             featuredMedia={featuredMedia}
  //             isShowAudioIcon={isShowAudioIcon}
  //             toggleRotate={toggleRotate}
  //             shouldRotate={shouldRotate}
  //             canFullscreen={canFullscreen}
  //             menuPosition={menuPosition}
  //             handleFullScreen={handleFullScreen}
  //             fullScreen={fullScreen}
  //             isShowMapFloorPlan={isShowMapFloorPlan}
  //             setIsActiveMap={setIsActiveMap}
  //             isActiveMap={isActiveMap}
  //             mapShowed={mapShowed}
  //             setOpenDropDown={setOpenDropDown}
  //             openDropDown={openDropDown}
  //             handleSelectMap={handleSelectMap}
  //             scenes={scenes}
  //             onSelect={onSelect}
  //             switchMode={switchMode}
  //             handleUpdateRoute={handleUpdateRoute}
  //             isSchoolLayout={isSchoolLayout}
  //             isAquaStyle={isAquaStyle}
  //           />
  //         )}

  //         {isSimpleLayout && (
  //           <SimpleLayoutIcons
  //             currentPano={currentPano}
  //             isAutoPlay={isAutoPlay}
  //             color={color}
  //             toggleHelpButton={toggleHelpButton}
  //             featuredMedia={featuredMedia}
  //             isShowAudioIcon={isShowAudioIcon}
  //             toggleRotate={toggleRotate}
  //             shouldRotate={shouldRotate}
  //             canFullscreen={canFullscreen}
  //             menuPosition={menuPosition}
  //             handleFullScreen={handleFullScreen}
  //             fullScreen={fullScreen}
  //             isShowMapFloorPlan={isShowMapFloorPlan}
  //             setIsActiveMap={setIsActiveMap}
  //             isActiveMap={isActiveMap}
  //             mapShowed={mapShowed}
  //             setOpenDropDown={setOpenDropDown}
  //             openDropDown={openDropDown}
  //             handleSelectMap={handleSelectMap}
  //             scenes={scenes}
  //             onSelect={onSelect}
  //             switchMode={switchMode}
  //             handleUpdateRoute={handleUpdateRoute}
  //             isSchoolLayout={isSchoolLayout}
  //             isAquaStyle={isAquaStyle}
  //             floorMaps={floorMaps}
  //             isSimpleLayout={isSimpleLayout}
  //           />
  //         )}

  //         {!isSchoolLayout && !isSimpleLayout && (
  //           <div
  //             className="icons_right"
  //             style={{
  //               display: 'flex',
  //             }}
  //           >
  //             {isBothersFurnitureLayout && (
  //               <div
  //                 className={`icon`}
  //                 onClick={() => backToDefaultScene(menuList, scenes, onSelect)}
  //               >
  //                 <BackToDefaultSceneButton
  //                   menuList={menuList}
  //                   currentPano={currentPano}
  //                 />
  //               </div>
  //             )}

  //             {shouldShowMapIcon && (
  //               <div
  //                 className={`icon`}
  //                 style={{
  //                   display: isShowOnMap ? 'flex' : 'none',
  //                 }}
  //                 onClick={() => handleUpdateRoute(configs.mapRoute)}
  //               >
  //                 <MapIcon />
  //               </div>
  //             )}

  //             {/* <div className={`icon`} onClick={() => switchMode()}>
  //               <AutoPlayIcon shouldRotate={isAutoPlay} activeColor={color} />
  //             </div>

  //             <div className={`icon`} onClick={toggleHelpButton}>
  //               <HelpIcon />
  //             </div> */}
  //             {featuredMedia.map && (
  //               <div
  //                 className={`icon`}
  //                 onClick={() => handleUpdateRoute(featuredMedia.map.id)}
  //               >
  //                 <FloorMapIcon />
  //               </div>
  //             )}
  //             {featuredMedia.contact && (
  //               <div
  //                 className={`icon`}
  //                 onClick={() => handleUpdateRoute(featuredMedia.contact.id)}
  //               >
  //                 <ContactFormIcon />
  //               </div>
  //             )}
  //             {isShowAudioIcon && (
  //               <AudioIcon activeColor={color} className={`icon`} />
  //             )}
  //             <div
  //               className={`icon`}
  //               onClick={() => {
  //                 toggleRotate();
  //               }}
  //             >
  //               <AutoRotateIcon
  //                 shouldRotate={shouldRotate}
  //                 activeColor={color}
  //               />
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default MenuForceMobile;
